module.exports = __webpack_public_path__ + "img/space2.6af933d4.jpg";